import ComingSoon from "@/components/ComingSoon";

export default function MemberArea() {
  return (
    <ComingSoon
      area="member"
      eyebrow="Members · Opening Soon"
      title="A private room for the global circle."
      body="The Members area will host private dispatches, project rooms, peer council, and direct invitations to gatherings. Add your name — we'll open the doors to the first wave personally."
      image="https://images.unsplash.com/photo-1769251968740-f8ffa70f9043?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxnbG9iYWwlMjBlYXJ0aCUyMHNwYWNlJTIwYmx1ZXxlbnwwfHx8fDE3ODIwOTQ3NjR8MA&ixlib=rb-4.1.0&q=85"
    />
  );
}
